import { ADIB_SURGE_REPORT, ADIB_SURGE_REPORT_SUCCESS, ADIB_SURGE_REPORT_ERROR, ADIB_SURGE_REPORT_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AdibSurgeReport = (state = initialState, action) => {
  switch (action.type) {
    case ADIB_SURGE_REPORT:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ADIB_SURGE_REPORT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ADIB_SURGE_REPORT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ADIB_SURGE_REPORT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AdibSurgeReport;
